var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
import ProspectSourceCategoryDomainService from "../Domain/ProspectSourceCategory/ProspectSourceCategory.service";
const BASE_URL = "/aviso/prospectSourceCategory";
export default class ProspectSourceCategoryService {
    static search(search, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield FetchService.getPagedResponse(BASE_URL + "/search", {
                query: search.query,
                max: options === null || options === void 0 ? void 0 : options.max,
                offset: options === null || options === void 0 ? void 0 : options.offset,
                sort: options === null || options === void 0 ? void 0 : options.sort,
                order: options === null || options === void 0 ? void 0 : options.order,
            });
            return Object.assign(Object.assign({}, resp), { data: resp.data.map((psc) => ProspectSourceCategoryDomainService.fromJSON(psc)) });
        });
    }
}
